var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"section"},[_c('Graph',{attrs:{"entries":_vm.entries}})],1),_c('section',{staticClass:"section"},[_c('List',{attrs:{"entries":_vm.entries}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }